import { curriculumAuthHeader, handleError } from '../helper';
import APIHelper from "../common/ApiHelper";
import APIURLConstants from "../common/ApiURLConstants";
import CurriculumAPIHelper from '../common/CurriculumApiHelper';


export const CurriculumMasterData = {

    getLevels,
    updatelevel,
    insertLevel,
    updateLevelOrder,
    getBadges,
    updateBadge,
    insertBadge,
    getResourceTypes,
    updateResourceType,
    insertResourceType,
    getResources,
    updateResource,
    insertResource,
    getQuestionTypes,
    updateQuestionType,
    insertQuestionType,
    getCurriculums,
    updateCurriculum,
    insertCurriculum,
    getSections,
    updateSection,
    insertSection,
    getMediaTypes,
    insertQuestion,
    updateQuestion,
    getQuestionBank,
    getQuestionLevels,
    getMediaURL,
    getSectionType,
    getAllQuizType
}


//levels
function getLevels() {
    return CurriculumAPIHelper.get(APIURLConstants.LEVELS_BY_TENANT, curriculumAuthHeader())
        .then(result => {
            return result.data;
        }).catch(handleError);
}

function updatelevel(data) {
    return CurriculumAPIHelper.post(APIURLConstants.UPDATE_LEVEL, data, curriculumAuthHeader())
        .then(data => {
            return data;
        }).catch(handleError);
}

function insertLevel(data) {
    return CurriculumAPIHelper.post(APIURLConstants.INSERT_LEVEL, data, curriculumAuthHeader())
        .then(data => {
            return data;
        }).catch(handleError);
}


function updateLevelOrder(data) {
    return CurriculumAPIHelper.post(APIURLConstants.UPDATE_LEVEL_ORDER, data, curriculumAuthHeader())
        .then(data => {
            return data;
        }).catch(handleError);
}
//Badges
function getBadges() {
    return CurriculumAPIHelper.get(APIURLConstants.BADGES_BY_TENANT, curriculumAuthHeader())
        .then(result => {
            return result.data;
        }).catch(handleError);
}

function updateBadge(data,type) {
    return CurriculumAPIHelper.post(APIURLConstants.UPDATE_BADGE, data, curriculumAuthHeader(type))
        .then(data => {
            return data;
        }).catch(handleError);
}

function insertBadge(data,type) {
    return CurriculumAPIHelper.post(APIURLConstants.INSERT_BADGE, data, curriculumAuthHeader(type))
        .then(data => {
            return data;
        }).catch(handleError);
}


//Resource Type
function getResourceTypes() {
    return CurriculumAPIHelper.get(APIURLConstants.RESOURCETYPES_BY_TENANT, curriculumAuthHeader())
        .then(result => {
            return result.data;
        }).catch(handleError);
}

function updateResourceType(data) {
    return CurriculumAPIHelper.post(APIURLConstants.UPDATE_RESOURCETYPE, data, curriculumAuthHeader())
        .then(data => {
            return data;
        }).catch(handleError);
}

function insertResourceType(data) {
    return CurriculumAPIHelper.post(APIURLConstants.INSERT_RESOURCETYPE, data, curriculumAuthHeader())
        .then(data => {
            return data;
        }).catch(handleError);
}

//Resource
function getResources(tenantUid) {
    return CurriculumAPIHelper.get(APIURLConstants.RESOURCES_BY_TENANT(tenantUid), curriculumAuthHeader())
        .then(result => {
            return result.data;
        }).catch(handleError);
}

function updateResource(data) {
    return CurriculumAPIHelper.post(APIURLConstants.UPDATE_RESOURCE, data, curriculumAuthHeader())
        .then(data => {
            return data;
        }).catch(handleError);
}

function insertResource(data) {
    return CurriculumAPIHelper.post(APIURLConstants.INSERT_RESOURCE, data, curriculumAuthHeader())
        .then(data => {
            return data;
        }).catch(handleError);
}

//Resource Type
function getQuestionTypes() {
    return CurriculumAPIHelper.get(APIURLConstants.QUESTIONTYPES_BY_TENANT, curriculumAuthHeader())
        .then(result => {
            return result.data;
        }).catch(handleError);
}

function updateQuestionType(data) {
    return CurriculumAPIHelper.post(APIURLConstants.UPDATE_QUESTIONTYPE, data, curriculumAuthHeader())
        .then(data => {
            return data;
        }).catch(handleError);
}

function insertQuestionType(data) {
    return CurriculumAPIHelper.post(APIURLConstants.INSERT_QUESTIONTYPE, data, curriculumAuthHeader())
        .then(data => {
            return data;
        }).catch(handleError);
}

//curriculums


function getCurriculums(tenantUid) {
    return CurriculumAPIHelper.get(APIURLConstants.CURRICULUMS_BY_TENANT, curriculumAuthHeader())
        .then(result => {
            return result.data;
        }).catch(handleError);
}

function updateCurriculum(data) {
    return CurriculumAPIHelper.post(APIURLConstants.UPDATE_CURRICULUM, data, curriculumAuthHeader())
        .then(data => {
            return data;
        }).catch(handleError);
}

function insertCurriculum(data) {
    return CurriculumAPIHelper.post(APIURLConstants.INSERT_CURRICULUM, data, curriculumAuthHeader())
        .then(data => {
            return data;
        }).catch(handleError);
}

//sections

function getSections(curriculumID) {
    return CurriculumAPIHelper.get(APIURLConstants.SECTIONS_BY_CURRICULUM(curriculumID), curriculumAuthHeader())
        .then(result => {
            return result.data;
        }).catch(handleError);
}

function updateSection(data) {
    return CurriculumAPIHelper.post(APIURLConstants.UPDATE_SECTION, data, curriculumAuthHeader())
        .then(data => {
            return data;
        }).catch(handleError);
}

function insertSection(data) {
    return CurriculumAPIHelper.post(APIURLConstants.INSERT_SECTION, data, curriculumAuthHeader())
        .then(data => {
            return data;
        }).catch(handleError);
}

function getMediaTypes() {
    return CurriculumAPIHelper.get(APIURLConstants.CURRICULUM_MEDIATYPES, curriculumAuthHeader())
        .then(result => {
            return result.data;
        }).catch(handleError);
}

function getQuestionBank(filter) {
    return CurriculumAPIHelper.post(APIURLConstants.GET_QUESTIONS, filter, curriculumAuthHeader())
        .then(result => {
            return result.data;
        }).catch(handleError);
}

function insertQuestion(data,type) {
    return CurriculumAPIHelper.post(APIURLConstants.INSERT_QUESTION, data, curriculumAuthHeader(type))
        .then(data => {
            return data;
        }).catch(handleError);
}

function updateQuestion(data,type) {
    return CurriculumAPIHelper.post(APIURLConstants.UPDATE_QUESTION, data, curriculumAuthHeader(type))
        .then(data => {
            return data;
        }).catch(handleError);
}

function getQuestionLevels() {
    return CurriculumAPIHelper.get(APIURLConstants.GET_ALL_QUESTION_LEVELS, curriculumAuthHeader())
        .then(result => {
            return result.data;
        }).catch(handleError);
}

function getMediaURL(data) {
    return CurriculumAPIHelper.get(APIURLConstants.GET_MEDIA_URL(data), curriculumAuthHeader())
        .then(result => {
            return result.data;
        }).catch(handleError);
}

function getSectionType() {
    return CurriculumAPIHelper.get(APIURLConstants.GET_SECTION_TYPE, curriculumAuthHeader())
        .then(result => {
            return result.data;
        }).catch(handleError);
}

function getAllQuizType() {
    return CurriculumAPIHelper.get(APIURLConstants.GET_QUIZ_TYPES, curriculumAuthHeader())
        .then(result => {
            return result.data;
        }).catch(handleError);
}

